export const service_article = [
    {
        img:"img1",
        title:"تحصيل ديون الأفراد",
        body:"لا شك أن متابعة و تحصيل الديون الخاصة بالأفراد لدى الغير هو امر مزعج للغاية . لذلك دعنا نتولى الأمر ونستعيد لك أموالك بشكل أسرع من خلال فريق احترافي مختص من ذوي الخبرة في التعامل مع هذه الحالات."
    },
    {
        img:"img2",
        title:"تحصيل ديون الشركات ",
        body:"نوفر للشركات و المؤسسات الكثير من الجهد و الوقت في تحصيل الديون المتعثرة او المستجدة منها بشكل سريع و فعال من خلال شبكة من الشركاء تغطي أماكن كثيرة على صعيد المملكة."
    },

]